// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3D1PD","title":"styles_title__2hZxU"};